// extracted by mini-css-extract-plugin
module.exports = {"app-page":"app-page--3a0tF","appPage":"app-page--3a0tF","eng":"eng--yZLL0","app":"app--1nxV0"};